import styled from 'styled-components';

export const Button = styled.button`
  background-color: ${({ theme }) => theme.palette.white};
  color: ${({ theme }) => theme.palette.BR300};
  border: 1px solid ${({ theme }) => theme.palette.BR300};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  width: 100%;
  max-width: 260px;
  font-size: 14px;
  font-weight: bold;
  border-radius: 8px;
  padding: 8px 0;
  cursor: pointer;
  transition: all 0.15s ease-in;

  &:hover {
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
  }
  &:disabled {
    opacity: 0.6;
    box-shadow: none;
  }

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    max-width: 100%;
  }
`;

export const NonCollapsableFilterContainer = styled.div`
  width: 100%;
  height: fit-content;
  padding: 8px 0;
  display: flex;
  justify-content: space-between;
`;

export const NonCollapsableFilterLeftItems = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.palette.brownishGrey};
  display: flex;
  align-items: flex-start;
`;

export const NonCollapsableFilterRightItems = styled.button`
  font-size: 14px;
  color: ${({ theme }) => theme.palette.eclipse};
  display: flex;
  align-items: center;
  background-color: transparent;
  border: none;
  gap: 2px;

  &:disabled {
    opacity: 0.5;
  }
`;

export const NonCollapsableFilterLeftText = styled.div`
  margin-left: 5px;
  font-size: 16px;
  font-weight: bold;
  color: ${({ theme }) => theme.palette.NL800};
`;

export const NonCollapsableFilterRightText = styled.div`
  margin-right: 5px;
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.R300};
`;
